export default {
  momentLocale: 'vi',
  Timeline: {
    expand: 'Mở rộng',
    fold: 'Thu gọn',
  },
  Balloon: {
    close: 'Đóng',
    confirm: 'Xác nhận',
    cancel: 'Hủy bỏ',
  },
  Card: {
    expand: 'Mở rộng',
    fold: 'Thu gọn',
  },
  Calendar: {
    today: 'Hôm nay',
    now: 'Giây phút này',
    ok: 'Xác nhận',
    clear: 'Xóa',
    month: 'Tháng',
    year: 'năm',
    prevYear: 'Năm trước',
    nextYear: 'năm sau',
    prevMonth: 'Tháng Trước',
    nextMonth: 'Tháng sau',
    prevDecade: '12 Năm Trước',
    nextDecade: 'Sau 12 năm',
    yearSelectAriaLabel: 'Chọn Năm',
    monthSelectAriaLabel: 'Chọn tháng',
    format: {
      months: '1 Tháng_2 Tháng_3 Tháng_4 Tháng_5 Tháng_6 Tháng_7 Tháng_8 Tháng_9 Tháng_10 Tháng_11 Tháng_12'.split(
        '_',
      ),
      shortMonths: '1 Tháng_2 Tháng_3 Tháng_4 Tháng_5 Tháng_6 Tháng_7 Tháng_8 Tháng_9 Tháng_10 Tháng_11 Tháng_12'.split(
        '_',
      ),
      weekdays: 'Chủ Nhật_Thứ Hai_Thứ Ba_Thứ Tư_Thứ Năm_Thứ Sáu_Thứ Bảy'.split('_'),
      shortWeekdays: 'Chủ Nhật_Thứ Hai_Thứ Ba_Thứ Tư_Thứ Năm_Thứ Sáu_Thứ Bảy'.split('_'),
      veryShortWeekdays: 'Chủ Nhật_Thứ Hai_Thứ Ba_Thứ Tư_Thứ Năm_Thứ Sáu_Thứ Bảy'.split('_'),
      yearLabel: 'Năm YYYY',
    },
  },
  DatePicker: {
    placeholder: 'Vui lòng chọn ngày',
    datetimePlaceholder: 'Vui lòng chọn ngày và giờ',
    monthPlaceholder: 'Vui lòng chọn tháng',
    yearPlaceholder: 'Vui lòng chọn năm',
    now: 'Bây giờ',
    selectTime: 'Chọn thời gian',
    selectDate: 'Chọn ngày',
    ok: 'Xác nhận',
    clear: 'Xóa',
    startPlaceholder: 'Ngày bắt đầu',
    endPlaceholder: 'Ngày kết thúc',
    hour: 'Thời gian',
    minute: 'phút',
    second: 'giây',
  },
  Dialog: {
    close: 'Đóng',
    ok: 'Đồng ý',
    cancel: 'Hủy',
  },
  Message: {
    closeAriaLabel: 'Đóng',
  },
  Pagination: {
    goTo: 'Đi đến',
    page: 'Trang',
    total: 'Trang {current}, tổng cộng {total} trang',
    labelPrev: 'Trang trước, trang hiện tại {current}',
    labelNext: 'Trang kế tiếp, trang hiện tại thứ {current}',
    inputAriaLabel: 'Vui lòng nhập số trang bạn muốn chuyển đến',
    selectAriaLabel: 'Vui lòng chọn số mục hiển thị trên mỗi trang',
    pageSize: 'Điều/Khổ',
  },
  Input: {
    clear: 'Xóa bỏ',
  },
  Select: {
    selectPlaceholder: 'Vui lòng chọn',
    autoCompletePlaceholder: 'Vui lòng nhập',
    notFoundContent: 'Không có lựa chọn',
    maxTagPlaceholder: 'Đã chọn {selected}/{total} mục',
  },
  Table: {
    empty: 'Không có dữ liệu',
    ok: 'Đồng ý',
    reset: 'Khôi phục',
    asc: 'Tăng dần',
    desc: 'Thứ tự giảm dần',
    expanded: 'Đã mở rộng',
    folded: 'Đã gập',
    filter: 'Lọc',
    selectAll: 'Chọn Tất cả',
  },
  TimePicker: {
    placeholder: 'Vui lòng chọn thời gian',
    startPlaceholder: 'Thời điểm bắt đầu',
    endPlaceholder: 'Thời điểm kết thúc',
    clear: 'Xóa bỏ',
    hour: 'giờ',
    minute: 'phút',
    second: 'giây',
  },
  Transfer: {
    items: 'mục',
    item: 'mục',
    moveAll: 'Di chuyển tất cả',
    searchPlaceholder: 'Vui lòng nhập',
    moveToLeft: 'Bỏ chọn phần tử',
    moveToRight: 'Đăng ký các phần tử đã chọn',
  },
  Upload: {
    card: {
      cancel: 'Hủy bỏ',
      addPhoto: 'Tải lên hình ảnh',
      download: 'Tải xuống',
      delete: 'Xóa',
    },
    drag: {
      text: 'Nhấp hoặc kéo tệp vào khung chấm đứt để tải lên',
      hint: 'Hỗ trợ các loại tập tin docx, xls, PDF, rar, zip, PNG, JPG và các loại khác',
    },
    upload: {
      delete: 'Xóa',
    },
  },
  Search: {
    buttonText: 'Tìm kiếm',
  },
  Tag: {
    delete: 'Xóa',
  },
  Rating: {
    description: 'Lựa chọn đánh giá',
  },
};
